import { render, staticRenderFns } from "./ClientFileSearch.vue?vue&type=template&id=236cb87c&"
import script from "./ClientFileSearch.vue?vue&type=script&lang=ts&"
export * from "./ClientFileSearch.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports